const updateUserName = (state, payload) => {
  state.userName = payload;
};
const updateAccessToken = (state, payload) => {
  state.accessToken = payload;
};

export default {
  updateAccessToken,
  updateUserName,
};
